import API from '../../../API/api';

export const redeemProductVoucher = async (voucherData, checkValidity) => {
  try {
    let response;
    response = await API.POST({
      apiPath: checkValidity ? '/cart/quote/' : '/cart/quote/voucher/',
      data: JSON.stringify({
        ...voucherData,
      }),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
    });

    return Promise.resolve(response);
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
